module.exports = __webpack_public_path__ + "static/media/5_The Cracked pot_ES.ce8839ed.txt";